<script>
import DeckSettingsModal from '~/components/modals/DeckSettingsModal'
import selectDeckForCopy from '~/queries/selectDeckForCopy'
import { deckSettingsModalOnboardingKey, defaultJoinSlide } from '~/common/decks'

export default {
  data () {
    return {
      deckSettingsModal: null
    }
  },
  beforeDestroy () {
    if (!this.deckSettingsModal) {
      return
    }
    this.deckSettingsModal.close()
    this.$nextTick(() => {
      this.deckSettingsModal.$destroy()
    })
  },
  methods: {
    openDeckSettingsModal (slideDeck, options) {
      this.trackEvent('Open Deck Settings Modal')

      return new Promise((resolve) => {
        this.deckSettingsModal = this.$buefy.modal.open({
          parent: this,
          fullScreen: false,
          component: DeckSettingsModal,
          width: 970,
          trapFocus: true,
          canCancel: ['x', 'outside'],
          events: {
            submit: (data) => {
              resolve(data)
            },
            back: () => {
              resolve({ back: true })
            }
          },
          onCancel: () => {
            const { domain, templateId, templateName } = options.trackingData || {}
            this.posthogCapture(`${domain}:wizard_cancel`, {
              template_id: templateId,
              template_name: templateName
            })
            resolve()
          },
          props: {
            themeData: slideDeck?.themeData || {},
            metaData: slideDeck?.metaData || {},
            eventSettings: slideDeck?.eventSettings || {},
            slides: slideDeck?.slides || [defaultJoinSlide()],
            slideDeckName: slideDeck?.name,
            ...options
          }
        })
      })
    },
    async startDeckSettingsModal (deckOrDeckId, options = {}) {
      // Avoid showing the modal if the user marked the "do not show again" checkbox
      if (this.hasOnboarded(deckSettingsModalOnboardingKey) && !options.forceOpen) {
        return new Promise((resolve) => {
          resolve({ disabled: true })
        })
      }

      let slideDeck = null

      if (deckOrDeckId) {
        if (typeof deckOrDeckId === 'object') {
          slideDeck = deckOrDeckId
        } else {
          const { data: { slideDecks } } = await this.$apollo.query({
            query: selectDeckForCopy,
            variables: {
              id: deckOrDeckId
            },
            fetchPolicy: 'no-cache'
          })
          slideDeck = slideDecks[0]
        }
      }

      return this.openDeckSettingsModal(slideDeck, options)
    }
  }
}
</script>
